import { useEffect, useState } from 'react';

export type AccessLevel = 'none' | 'view' | 'full';

// Access level of the logged-in user over one permission `entity` (the same
// none/view/full model the Roles matrix edits): an "all" row means 'full', a
// "read" row means 'view'. Read live from GET /me, which already merges
// permissions inherited through roles and groups. While loading, or if /me
// fails, the level is 'none' so nothing sensitive shows up by mistake.
export const useEntityAccess = (entity: string) => {
  const [level, setLevel] = useState<AccessLevel>('none');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const fetchAccess = async () => {
      try {
        const Cookies = (await import('universal-cookie')).default;
        const userCookie = new Cookies().get('101Obex');
        if (!userCookie || !userCookie.token) return;

        const ObexRequestsHandlerP80 = (await import('../handlers/ObexRequestsHandlerP80')).default;
        let res = await ObexRequestsHandlerP80.get('/me', { access_token: userCookie.token });
        if (res.data) res = res.data;

        const meData = res?.response ?? res?.result?.response;
        const permissions: any[] = Array.isArray(meData?.permissions) ? meData.permissions : [];
        let next: AccessLevel = 'none';
        permissions.forEach((p) => {
          if (p.entity !== entity) return;
          if (p.action === 'all') next = 'full';
          else if (p.action === 'read' && next !== 'full') next = 'view';
        });
        if (!cancelled) setLevel(next);
      } catch (fetchError) {
        console.error('Error fetching permissions (/me):', fetchError);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchAccess();
    return () => { cancelled = true; };
  }, [entity]);

  return { level, loading };
};
